interface CompanyFilterScopeNoteProps {
  active: boolean;
  text: string | null;
}

// AC16c — info note above chart when Company filter is non-default.
export function CompanyFilterScopeNote({ active, text }: CompanyFilterScopeNoteProps) {
  if (!active || !text) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="company-filter-info-note"
      style={{
        background: '#e3f2fd',
        color: '#0d47a1',
        padding: '8px 12px',
        borderRadius: '4px',
        margin: '0 0 12px 0',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <span aria-hidden="true">&#x2139;</span>
      <span>{text}</span>
    </div>
  );
}
